/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventsMemberController', DinghyEventsMemberController);

    DinghyEventsMemberController.$inject = ['$scope', '$sce', '$http', '$state', 'DateUtils', 'calendarConfig', 'moment', '$filter', 'PrincipalProfile'];

    function DinghyEventsMemberController ($scope, $sce, $http, $state, DateUtils, calendarConfig, moment, $filter, PrincipalProfile) {
        var $translate = $filter('translate');
        var vm = this;
        vm.today = new Date().toISOString().split('T')[0];

        calendarConfig.i18nStrings.weekNumber = 'KW {week}';
        moment.locale("de", {
            week: {
                dow: 1
            }
        });

        vm.dinghyEvents = [];
        vm.calendarEvents = [];

        vm.calendarView = 'month';
        vm.viewDate = new Date();

        vm.calendarEventClicked = function(event) {
            $state.go(event.isBooked || !event.isActive || event.freePlaces <= 0 ? 'member.dinghy-events.detail' : 'member.dinghy-events.book', {'id': event.id});
        };

        PrincipalProfile.identity(false).then(function(profile) {
            vm.currentProfile = profile;
            loadAll();
        });

        const redColor = '#d9534f';
        const yellowColor = '#f0ad4e';
        const greenColor = '#5cb85c';
        const blueColor = '#5bc0de';
        const noPlacesColor = 'darkgrey';
        const leisureColor = '#0000ff';
        const regattaColor = '#ff00ff';
        const trainingColor = '#7F007F';
        const engagementColor = '#3fff00';
        function loadAll () {
            $http.get('api/member/dinghy-events/').then(function(response) {
                var calendarEvents = response.data.calendarEvents;
                var bookedEvents = response.data.bookedEvents;

                for(var index = 0; index < bookedEvents.length; index++) {
                    bookedEvents[index].fromDate = DateUtils.convertDateTimeFromServer(bookedEvents[index].fromDate);
                    bookedEvents[index].untilDate = DateUtils.convertDateTimeFromServer(bookedEvents[index].untilDate);
                }
                vm.dinghyEvents = bookedEvents;

                // process calendar events
                vm.calendarEvents = [];
                for(var index = 0; index < calendarEvents.length; index++) {
                    calendarEvents[index].fromDate = DateUtils.convertDateTimeFromServer(calendarEvents[index].fromDate);
                    calendarEvents[index].untilDate = DateUtils.convertDateTimeFromServer(calendarEvents[index].untilDate);

                    var primaryColor = null;
                    var secondaryColor = null;
                    var freePlaces = calendarEvents[index].freePlaces;
                    var freePlacesString = "";
                    var isBooked = calendarEvents[index].bookingStatus !== null;

                    if(freePlaces === 0) {
                        freePlacesString = "Ausgebucht";
                        primaryColor = secondaryColor = noPlacesColor;
                    } else if(freePlaces === -1) {
                        freePlacesString = "Warteliste";
                    } else if(freePlaces === 1) {
                        freePlacesString = 1 + " freier Platz";
                    } else {
                        freePlacesString = freePlaces + " freie Plätze";
                    }
                    var godparentIcon = '';
                    if(calendarEvents[index].godparentId === vm.currentProfile.id) {
                        godparentIcon = '<span class="glyphicon glyphicon-tower"></span> ';
                    }
                    if (isBooked) {
                        // Use color indicating the booking status
                        freePlacesString += " | " + $translate('askApp.EnumBookingStatusType.' + calendarEvents[index].bookingStatus);
                        switch (calendarEvents[index].bookingStatus) {
                            case "angemeldet":
                                primaryColor = secondaryColor = calendarEvents[index].canceled ? redColor : calendarEvents[index].godparentId !== null ? greenColor : yellowColor;
                                break;
                            case "warteliste":
                                primaryColor = secondaryColor = calendarEvents[index].canceled ? redColor : yellowColor;
                                break;
                            case "abgelehnt":
                            case "zurueckgetreten":
                                primaryColor = secondaryColor = redColor;
                                break;
                        }
                    } else if (freePlaces !== 0) {
                        // Use Event Type to define the color
                        switch (calendarEvents[index].type) {
                            case "leisure":
                                primaryColor = secondaryColor = leisureColor;
                                break;
                            case "regatta":
                                primaryColor = secondaryColor = regattaColor;
                                break;
                            case "training":
                                primaryColor = secondaryColor = trainingColor;
                                break;
                            case "engagement":
                                primaryColor = secondaryColor = engagementColor;
                                break;
                        }
                    }

                    var event = {
                        title: godparentIcon + calendarEvents[index].name + " | " + freePlacesString,
                        id: calendarEvents[index].id,
                        isBooked: isBooked,
                        freePlaces: freePlaces,
                        isActive: calendarEvents[index].active,
                        startsAt: calendarEvents[index].fromDate,
                        endsAt: calendarEvents[index].untilDate,
                        color: {
                            primary: primaryColor,
                            secondary: secondaryColor
                        },
                        actions: [{
                            label: "<i class='glyphicon glyphicon-eye-open'></i>",
                            cssClass: "brightLink",
                            onClick: function(args) {
                                $state.go('member.dinghy-events.detail', {'id': args.calendarEvent.id});
                            }
                        }]
                    };
                    vm.calendarEvents.push(event);
                }
            });
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }
    }
})();
